import { Component } from 'preact';

/**
 * Higher order component which extends a component by accepting a mounted callback, which
 * gets called in the componentDidMount lifecycle method.
 *
 * props:
 * - mounted: (optional) callback function
 * - other props passed down into wrapped component
 */
const notifyMounted = WrappedComponent => {

	return class extends Component {

		componentDidMount() {
			if (typeof this.props.mounted === 'function') {
				this.props.mounted();
			}
		}

		render(props) {
			const { mounted, ...rest } = props;
			return <WrappedComponent {...rest} />;
		}

	};

};

export default notifyMounted;



// WEBPACK FOOTER //
// ./components/notify-mounted/index.js